import { render, staticRenderFns } from "./noteItem.vue?vue&type=template&id=60a0684b&scoped=true&"
import script from "./noteItem.vue?vue&type=script&lang=js&"
export * from "./noteItem.vue?vue&type=script&lang=js&"
import style0 from "./noteItem.vue?vue&type=style&index=0&id=60a0684b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a0684b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a0684b')) {
      api.createRecord('60a0684b', component.options)
    } else {
      api.reload('60a0684b', component.options)
    }
    module.hot.accept("./noteItem.vue?vue&type=template&id=60a0684b&scoped=true&", function () {
      api.rerender('60a0684b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/notes/noteItem.vue"
export default component.exports